/* 🤖 this file was generated by svg-to-ts */
export const emperorIconFileQuestionMark1: {
  name: 'file_question_mark_1';
  data: string;
} = {
  name: 'file_question_mark_1',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><g><path d="M11 8c-2.21 0-4 1.79-4 4h2c0-1.11.89-2 2-2 1.1 0 2 .89 2 2 0 1.1-.9 2-2 2h-1v2h2v-.13c1.72-.45 3-2.013 3-3.88 0-2.21-1.8-4-4-4Z"/><path d="M11 17a1 1 0 1 0 0 2 1 1 0 1 0 0-2Z"/><path d="M15.414 1H4c-1.11 0-2 .89-2 2v18c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5.586L15.414 1ZM4 21V3h10v4h4l0 14H3.99Z"/></g></svg>`
};
